import React, { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import Loader from "../../Global/Loader";
import ContentWrapper from "../../template/Layout/ContentWrapper";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsivePie } from "@nivo/pie";
import { withNamespaces } from "react-i18next";
import { ChartComponent } from "../Components/Charts.js";
import Axios from "axios";
import { Services } from "../../../repositories/clients/Services";
import DataTable from "../Components/DataTable";
import FormFilter from "./components/form";
import { DatePicker } from "antd";
import moment from "moment";
import { Dropdown } from "semantic-ui-react";
import { Button, Card, Label, Row } from "reactstrap";
import { connect } from "react-redux";
import { saveAs } from "file-saver";
import { FullLoader } from "../Home/components/Loader";
import { BasicTooltip } from "@nivo/tooltip";
import { Link } from "react-router-dom";
import { message } from "antd";

const { RangePicker } = DatePicker;

function Finance(params) {
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [numberPageInvoice, setNumberPageInvoice] = useState(1);
  const [activeInvoicePage, setActiveInvoicePage] = useState(1);
  const [limitInvoice] = useState(10);
  const [searchInvoice, setSearchInvoice] = useState("");
  const [advancedObj, setAdvancedObj] = useState(undefined);
  const [filtros, setFiltros] = useState(undefined);
  const [dataInvoice, setDataInvoice] = useState([]);
  const [totalInvoice, setTotalInvoice] = useState([]);
  const [excelInvoiceLoading, setExcelInvoiceLoading] = useState(false);
  const [catalogCombo, setCatalogCombo] = useState([]);
  const [key, setKey] = useState(1);
  const [sumaryInfo, setSumaryInfo] = useState("");
  const [updateDate, setUpdateDate] = useState("");
  const [headers] = useState([
    params.t("invoice_number"),
    params.t("compliance_no"),
    params.t("job_number"),
    params.t("organization_name"),
    params.t("transaction_date"),
    params.t("transaction_type"),
    params.t("due_date"),
    params.t("local_currency"),
    params.t("localtotal_amount"),
    params.t("localtotal_with_amount"),
    params.t("outstanding_amount"),
    //params.t("job_number"),
    params.t("transport_mode"),
    // params.t("status"),
  ]);
  const [keys] = useState([
    "InvoiceNumber",
    "ComplianceNo",
    "ShipmentNumber",
    //"BranchName",
    "CustomerName",
    "InvoiceDate",
    "Type",
    "DueDate",
    "Currency",
    "TotalAmount",
    "TotalVATAmount",
    "OutstandingAmount",
    //"ShipmentNumber",
    "TransportMode",
    // "Status",
  ]);

  const [graphics, setGraphics] = useState({
    total_invoice: {
      data: [["invoice", "total", { type: "string", role: "tooltip" }]],
    },
    // total_status: { data: [] },
    transport_mode: { data: [] },
    concept: { data: [] },
  });
  const [columns] = useState([
    {
      label: "",
      key: "",
      CollapseTable: true,
      flatColor: true,
      keydatavalidate: "Status",
      minWidth: 50,
      maxWidth: 50,
    },
    {
      label: "",
      key: "",
      minWidth: 45,
      maxWidth: 45,
      showAllText: true,
      custom: (value) => (
        <button
          onClick={() =>
            downloadPdf(
              value.ShipmentNumber,
              value.CompanyCode,
              value.InvoiceNumber
            )
          }
        >
          {value.ShipmentNumber ? (
            <i
              className="far fa-file-pdf fa-2x"
              title="Documents"
              style={{ color: "red", cursor: "pointer" }}
            />
          ) : (
            ""
          )}
        </button>
      ),
    },
    {
      label: params.t("invoice_number"),
      key: "InvoiceNumber",
      minWidth: 120,
      maxWidth: 120,
      showAllText: true,
    },
    {
      label: params.t("compliance_no"),
      key: "ComplianceNo",
      minWidth: 120,
      maxWidth: 120,
      showAllText: true,
    },
    {
      label: params.t("job_number"),
      key: "ShipmentNumber",
      minWidth: 120,
      maxWidth: 120,
      showAllText: true,
      custom: (value) =>
        value.FlagShipment !== 0 ? (
          <Link
            to={`${"shipmentsDetail/" + value.ShipmentId}`}
            className="linkDetail"
          >
            {value.ShipmentNumber}
          </Link>
        ) : (
          <Label>{value.ShipmentNumber}</Label>
        ),
    },
    /*{
      label: params.t("branch_name"),
      key: "BranchName",
      minWidth: 240,
      maxWidth: 240,
      showAllText: true,
    },*/
    {
      label: params.t("organization_name"),
      key: "CustomerName",
      minWidth: 230,
      maxWidth: 230,
      showAllText: true,
    },
    {
      label: params.t("transaction_date"),
      key: "InvoiceDate",
      minWidth: 100,
      maxWidth: 100,
      showAllText: true,
    },
    {
      label: params.t("transaction_type"),
      key: "Type",
      minWidth: 100,
      maxWidth: 100,
      showAllText: true,
    },
    {
      label: params.t("due_date"),
      key: "DueDate",
      minWidth: 100,
      maxWidth: 100,
      showAllText: true,
    },
    {
      label: params.t("local_currency"),
      key: "Currency",
      minWidth: 100,
      maxWidth: 100,
      showAllText: true,
    },
    {
      label: params.t("localtotal_amount"),
      key: "TotalAmount",
      minWidth: 160,
      maxWidth: 160,
      showAllText: true,
      custom: (value) => (
        <span>
          {currencyFormatter({
            currency: "USD",
            value: Number(value.TotalAmount),
          })}
        </span>
      ),
    },
    {
      label: params.t("localtotal_with_amount"),
      key: "TotalVATAmount",
      minWidth: 160,
      maxWidth: 160,
      showAllText: true,
      custom: (value) => (
        <span>
          {currencyFormatter({
            currency: "USD",
            value: Number(value.TotalVATAmount),
          })}
        </span>
      ),
    },
    // {
    //   label: params.t("outstanding_amount"),
    //   key: "OutstandingAmount",
    //   minWidth: 120,
    //   maxWidth: 120,
    //   showAllText: true,
    //   custom: (value) => (
    //     <span>
    //       {currencyFormatter({
    //         currency: "USD",
    //         value: Number(value.OutstandingAmount),
    //       })}
    //     </span>
    //   ),
    // },
    /* {
      label: params.t("job_number"),
      key: "ShipmentNumber",
      minWidth: 120,
      maxWidth: 120,
      showAllText: true,
      custom: (value) =>
        value.FlagShipment !== 0 ? (
          <Link
            to={`${"shipmentsDetail/" + value.ShipmentId}`}
            className="linkDetail"
          >
            {value.ShipmentNumber}
          </Link>
        ) : (
          <Label>{value.ShipmentNumber}</Label>
        ),
    },*/
    {
      label: params.t("transport_mode"),
      key: "TransportMode",
      minWidth: 120,
      maxWidth: 120,
      showAllText: true,
    },
    // {
    //   label: params.t("status"),
    //   key: "Status",
    //   minWidth: 100,
    //   maxWidth: 100,
    //   showAllText: true,
    // },
  ]);
  const [subTable] = useState([
    {
      label: params.t("line"),
      key: "LineNo",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      label: params.t("code"),
      key: "Code",
      minWidth: 100,
      maxWidth: 100,
    },
    {
      label: params.t("concept"),
      key: "Concept",
      minWidth: 240,
      maxWidth: 230,
    },
    {
      label: params.t("amount"),
      key: "Amount",
      minWidth: 230,
      maxWidth: 230,
      custom: (value) => (
        // <span>{currencyFormat(parseFloat(value.Amount))}</span>
        <span>
          {currencyFormatter({
            currency: "USD",
            value: Number(value.Amount),
          })}
        </span>
      ),
    },
  ]);

  const downloadPdf = async (shipmentNumber, companyCode, nameDocument) => {
    try {
      setLoader(false);
      let data = {
        shipmentNumber,
        companyCode,
        nameDocument,
      };
      let url = `${Services.DOCUMENTS.path}documents/finance-obl`;
      let res = await Axios.post(url, data);
      if (res.data && res.data.data) {
        const fileName = `${nameDocument}.pdf`;
        const linkSource = `data:application/pdf;base64,${res.data.data}`;
        saveAs(linkSource, fileName);
      } else {
        message.error({
          content: params.t("document_not_found"),
        });
      }
      setLoader(true);
    } catch (error) {
      console.log("🚀 ~ file: index.js:153 ~ downloadPdf ~ error", error);
      message.error({
        content: params.t("error_on_download_doc"),
      });
      setLoader(true);
    }
  };

  const get_graphics = useCallback(async () => {
    let data = {
      userId: params._user,
      customers: params.clients,
      lang: params.lng,
    };
    try {
      let url = `${Services.finance.path}finance/data-graphics`;
      let res = await Axios.post(url, data);
      let dataGraphics = res.data.data;

      dataGraphics.forEach((e) => {
        if (e.Type === 1) {
          graphics.total_invoice.data.push([
            e.Name,
            Number(e.Total),
            `Total: ${currencyFormatter({
              currency: "USD",
              value: Number(e.Total),
            })} `,
          ]);
        }
        //  else if (e.Type === 2) {
        //   // graphics.total_status.data.push([e.Name, Number(e.Total)]);
        //   graphics.total_status.data.push({
        //     id: e.Name,
        //     label: e.Name,
        //     value: Number(e.Total),
        //   });
        // }
        else if (e.Type === 3) {
          graphics.transport_mode.data.push({
            id: e.Name,
            label: e.Name,
            value: Number(e.Total),
          });
          // graphics.transport_mode.data.push([e.Name, Number(e.Total)]);
        } else if (e.Type === 4) {
          graphics.concept.data.push({
            id: e.Name,
            label: e.Name,
            invoicing: Number(e.Total),
            color: "004cac",
            order: Number(e.Order),
          });
          // graphics.concept.keys.push(e.Name);
          // graphics.concept.data.push([e.Name, Number(e.Total)]);
        } else if (e.Type === 5) {
          setUpdateDate(moment(e.Name).format("DD-MM-YYYY"));
        }
      });
      graphics.concept.data.sort((a, b) => b.order - a.order);
      setGraphics({ graphics, ...graphics });
      setKey(Math.random());
    } catch (error) {
      console.log(
        "🚀 ~ file: index.js:22 ~ constget_graphics=useCallback ~ error:",
        error
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function currencyFormatter({ currency, value }) {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      minimumFractionDigits: 2,
      currency,
    });
    return formatter.format(value);
  }

  function generateFilters(cat) {
    let catalogs = cat ? cat : catalogCombo;

    let Inputs = FormFilter.map((e, i) => {
      if (e.type === "Datetime")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {params.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <RangePicker
              className="col-md-12"
              placeholder={[params.t("start_date"), params.t("end_date")]}
              value={
                Array.isArray(e.values)
                  ? e.values.length > 0
                    ? [
                      moment(new Date(e.values[0].init)),
                      moment(new Date(e.values[0].end)),
                    ]
                    : []
                  : []
              }
              style={{
                height: "36px",
                borderRadius: ".3em",
                borderColor: "#CCCCCC",
              }}
              id={e.id}
              onChange={(evt) => {
                handleChangeDatePicKer(e.id, evt, cat);
              }}
              size="large"
              format={e.format}
            />
          </div>
        );
      else if (e.type === "multipleSelect")
        return (
          <div
            key={e.id}
            className={e.class}
            style={{ marginTop: 5, marginBottom: 5 }}
          >
            <label className="labelTitleAvancSearc">
              {params.t(e.label)} {e.undefined ? "!" : ""}
            </label>
            <Dropdown
              className="NewClass"
              onChange={(evt, { value }) =>
                handleChangeSelectMultiple(e.id, value, cat)
              }
              id={e.id}
              options={catalogs[e.options]}
              clearable
              search
              selection
              fluid
              value={e.values}
              multiple
              allowAdditions
            />
          </div>
        );
      return null;
    });
    let NewInput = (
      <div className="row">
        <div className="col-12 d-flex justify-content-end">
          <Button
            className="mr-3"
            onClick={findAdvanced}
            color="primary"
            style={{ width: "auto" }}
            title={params.t("apply_filter")}
          >
            {params.t("apply")}
          </Button>
          <em
            class="fa-2x mr-2 fas fa-eraser"
            style={{
              color: "#0060a8",
              marginTop: "7px",
              cursor: "pointer",
            }}
            title={params.t("remove_filters")}
            onClick={() => {
              resetAdvance(cat);
            }}
          />
        </div>
        {Inputs}
      </div>
    );
    setFiltros(NewInput);
  }

  function resetAdvance(cat) {
    FormFilter.forEach((advData) => {
      advData.values = [];
    });

    generateFilters(cat);
    findAdvanced();
    // this.setState({ advancedSearch2 }, () => {
    //   this.findAdvanced();
    //   this.generateFilters();
    // });
  }

  function handleChangeSelectMultiple(id, value, cat) {
    for (let i = 0; i < FormFilter.length; i++) {
      const e = FormFilter[i];
      if (e.id === id) {
        e.values = value;
      }
    }

    generateFilters(cat);
    // findAdvanced();

    // this.setState({ advancedSearch2 }, () => {
    //   this.generateFilters();
    //   this.findAdvanced();
    // });
  }

  function handleChangeDatePicKer(name, evt, cat) {
    try {
      if (evt) {
        FormFilter.forEach((item) => {
          if (item.id === name) {
            item.values = [
              {
                init: evt[0].format("YYYY-MM-DD HH:mm:ss"),
                end: evt[1].format("YYYY-MM-DD HH:mm:ss"),
              },
            ];
          }
        });
        generateFilters(cat);
        findAdvanced();
      } else {
        FormFilter.forEach((search) => {
          if (search.id === name) {
            search.values = [];
          }
        });
        generateFilters(cat);
        findAdvanced();
      }
    } catch (error) {
      console.log(
        "🚀 ~ file: index.js:242 ~ handleChangeDatePicKer ~ error:",
        error.message
      );
    }
  }

  function findAdvanced() {
    let obj = [];
    FormFilter.forEach((e) => {
      if (e.values && e.values.length > 0) {
        let newPush = {
          id: e.id2,
          UseIN: true,
          isDate: e.type === "Datetime" ? true : false,
          value: e.values,
        };
        obj.push(newPush);
      } else {
        obj.push({
          id: e.id,
          UseIN: false,
          value: e.value,
        });
      }
    });
    setAdvancedObj(obj);
    setNumberPageInvoice(1);
    setActiveInvoicePage(1);

    // this.setState(
    //   { advancedObj: obj, numberPageInvoice: 1, activeInvoicePage: 1 },
    //   () => {
    //     this.getInvoiceInfo();
    //   }
    // );

    getInvoiceInfo(searchInvoice, numberPageInvoice, obj);
  }

  const getInvoiceInfo = useCallback(
    async (search, page, obj) => {
      let data = {
        client: params.clients ? JSON.stringify(params.clients) : "[0]",
        pag: search ? 1 : page ? page : numberPageInvoice,
        limit: limitInvoice,
        EsDTA: 0,
        search: search ? search : "",
        advanced: obj,
      };
      // console.log("🚀 ~ file: index.js:368 ~ getInvoiceInfo ~ data:", data);

      try {
        let url = `${Services.finance.path}finance/data-finance`;
        let res = await Axios.post(url, data);
        // console.log("🚀 ~ file: index.js:505 ~ res:", res)

        setDataInvoice(res.data.data);
        setTotalPages(res.data.totalPage);
        setLoader(true);
        setTotalInvoice(res.data.total);
      } catch (error) {
        setLoader(true);

        console.log("🚀 ~ file: index.js:299 ~ getInvoiceInfo ~ error:", error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchInvoice, numberPageInvoice, advancedObj]
  );

  function setInvoiceSearch(value) {
    setSearchInvoice(value ? value : "");
    setActiveInvoicePage(1);
    setNumberPageInvoice(1);

    getInvoiceInfo(value ? value : "");
  }

  function changePage(e, { activePageOrder }) {
    setNumberPageInvoice(activePageOrder);
    setActiveInvoicePage(activePageOrder);

    getInvoiceInfo(searchInvoice, activePageOrder, advancedObj);
  }

  async function getCatalogs() {
    let data = {
      client: params.clients ? JSON.stringify(params.clients) : "[0]",
    };

    try {
      let url = `${Services.finance.path}finance/filter-catalogs`;
      let res = await Axios.post(url, data);
      setCatalogCombo(res.data.data);
      generateFilters(res.data.data);
      resetAdvance(res.data.data);
    } catch (error) {
      console.log("🚀 ~ file: index.js:445 ~ getCatalogs ~ error:", error);
    }
  }

  const generateInvoiceExcel = useCallback(async () => {
    setExcelInvoiceLoading(true);
    let body = {
      client: params.clients ? JSON.stringify(params.clients) : "[0]",
      pag: numberPageInvoice,
      limit: limitInvoice,
      EsDTA: 0,
      search: searchInvoice,
      advanced: advancedObj,
      query: {
        allData: true,
      },
    };

    try {
      let url = `${Services.finance.path}finance/data-finance`;
      let res = await Axios.post(url, body);
      let data = res.data.data;

      if (data && data.length > 0) {
        data.forEach((d) => {
          d.TotalAmount = parseFloat(d.TotalAmount);
        });
      }

      let dateNow = new Date();
      let titleDownload = `${params.t("xls_file_name")}-${dateNow.getFullYear() +
        (dateNow.getMonth() + 1).toString().padStart(2, "0") +
        dateNow.getDate().toString().padStart(2, "0")
        }`;
      let info = {
        config: {},
      };
      let options = {
        headers: headers,
        keys: keys,
        image: {
          name: "obl",
        },
        sheetName: params.t("Invoices"),
      };

      let _url = `${Services.REPORT.path}/report/dynamic/xlsx`;
      const getXlsxFile = await Axios.post(_url, {
        info,
        data,
        options,
      });

      if (getXlsxFile.data.base64) {
        const fileName = titleDownload + ".xlsx";
        const linkSource = `data:application/xlsx;base64,${getXlsxFile.data.base64}`;
        saveAs(linkSource, fileName);
      }

      setExcelInvoiceLoading(false);
    } catch (error) {
      console.log(
        "🚀 ~ file: index.js:419 ~ generateInvoiceExcel ~ error:",
        error
      );
      setExcelInvoiceLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numberPageInvoice, searchInvoice, advancedObj]);

  useEffect(() => {
    let data = {
      client: params.clients ? JSON.stringify(params.clients) : "[0]",
    };

    try {
      let url = `${Services.finance.path}finance/data-totals`;
      Axios.post(url, data).then((res) => {
        // let data = res.data.data;
        let Info = (
          <>
            <Row>
              {/* <div className="col-xs-12 col-md-6 col-lg-6">
              <p>
                <span className="title-custom-value">
                  {params.t("total_pending_docs")}
                </span>
              </p>
              <span className="label-euro">
                {Number(res.data.data.total_pending).toLocaleString("En-us")}
              </span>
            </div> */}
              <div className="col-xs-12 col-md-12 col-lg-12">
                <p>
                  <span className="title-custom-value">
                    {params.t("total_docs")}
                  </span>
                  <br />
                  <span className="title-custom-value">
                    {`
                  ${Number(totalInvoice).toLocaleString("En-us")}
                  of
                  ${Number(res.data.data.total_invoices).toLocaleString(
                      "En-us"
                    )}`}
                  </span>
                </p>
              </div>
              {/* <div className="col-xs-12 col-md-6 col-lg-6">
            <p>
              <span className="titleCard">
                {this.props.t("total_docs")}
              </span>
            </p>
            <span className="label-euro">{totalInvoices}</span>
          </div> */}
            </Row>
          </>
        );
        setSumaryInfo(Info);
      });
    } catch (error) {
      console.log("🚀 ~ file: index.js:568 ~ getTotals ~ error:", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalInvoice]);

  useEffect(() => {
    getInvoiceInfo();
    get_graphics();
    // generateFilters();
    getCatalogs();
    //getTotals();
    // resetAdvance()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Loader hidden={loader} />
      <ContentWrapper>
        <div className="content-heading">
          <div className="col-8">
            <legend className="legendBasic">
              <i
                // style={{ fontSize: "28px" }}
                className="demo-icon icon-10abr23-iconosmagicdome-10_"
              ></i>
              {params.t("Finance")}
            </legend>
          </div>

          <div className="col-4 d-flex justify-content-end last-update">
            {`${params.t("last_update") + updateDate}`}
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-6 col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    className="row"
                  >
                    <div className="col-xs-12 col-md-9 col-lg-9 card-title">
                      {params.t("Graphic1")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {!loader ? (
                  <FullLoader />
                ) : (
                  <ChartComponent
                    type="LineChart"
                    data={
                      graphics.total_invoice.data
                        ? graphics.total_invoice.data
                        : []
                    }
                    width="100%"
                    height="300px"
                    options={{
                      chartArea: {
                        height: "70%",
                        // width: "80%",
                        width: "100%",
                        left: "17%",
                      },
                      legend: "none",
                      curveType: "function",
                      // vAxis: {
                      //   minValue: 0,
                      //   format: "$#,###",
                      // },
                      vAxis: {
                        viewWindow: { min: 0 },
                        format: "currency",
                        textStyle: { color: "#535353", fontSize: 11 },
                      },
                      hAxis: { textStyle: { color: "#535353", fontSize: 11 } },

                      pointSize: 5,
                      series: {
                        0: {
                          color: "#0060a8",
                          lineWidth: 2,
                        },
                      },
                    }}
                    id={"chartDashboard"}
                  />
                )}
              </div>
            </div>
          </div>
          {/* <div className="col-xs-12 col-md-6 col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  <div style={{ display: "flex" }} className="row">
                    <div className="col-md-8 col-lg-8 col-sm-8 col-8">
                      {params.t("Graphic2")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body equalsWidth">
                {!loader ? (
                  <FullLoader />
                ) : (
                  <ResponsivePie
                    key={key}
                    data={graphics.total_status.data}
                    // margin={{ top: 20, right: 20, bottom: 50, left: -50 }}
                    margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
                    pixelRatio={1}
                    startAngle={-18}
                    // innerRadius={0.5}
                    cornerRadius={0}
                    padAngle={0.7}
                    // colors={colors}
                    colors={["#66969e", "#0060a8"]}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", "0"]],
                    }}
                    legends={[
                      {
                        // anchor: 'center',
                        anchor: "center",
                        direction: "column",
                        // direction: 'column',
                        justify: false,
                        // translateX: 180,
                        translateX: 185,
                        translateY: 0,
                        itemsSpacing: 10,
                        itemWidth: 100,
                        // itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: "#535353",
                        itemDirection: "left-to-right",
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: "circle",
                        effects: [
                          {
                            on: "hover",
                            style: {
                              itemTextColor: "#000",
                            },
                          },
                        ],
                      },
                    ]}
                    tooltip={(val) => {
                      return (
                        <div
                          className="row"
                          style={{
                            border: "1px #0060a8 solid",
                            backgroundColor: "#fff",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div className="col-12 col-md-12 col-lg-12">
                            <h5>
                              {" "}
                              {val.datum.id} : $
                              {Number(val.datum.value).toLocaleString("En-us")}{" "}
                            </h5>
                          </div>
                        </div>
                      );
                    }}
                    slicesLabelsSkipAngle={20}
                    arcLabelsTextColor="#fff"
                    arcLabelsSkipAngle={20}
                    enableArcLinkLabels={false}
                    arcLabel={function (e) {
                      return "$" + Number(e.value).toLocaleString("En-us");
                    }}
                  />
                )}
              </div>
            </div>
          </div> */}
          <div className="col-xs-12 col-md-6 col-lg-6 ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  <div style={{ display: "flex" }} className="row">
                    <div className="col-md-8 col-lg-8 col-sm-8 col-8">
                      {params.t("Graphic3")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                {!loader ? (
                  <FullLoader />
                ) : (
                  <ResponsivePie
                    key={key}
                    data={graphics.transport_mode.data}
                    // margin={{ top: 20, right: 20, bottom: 50, left: -50 }}
                    margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
                    pixelRatio={1}
                    startAngle={-18}
                    innerRadius={0.5}
                    cornerRadius={0}
                    padAngle={0.7}
                    // colors={colors}
                    colors={["#0060a8", "#66969e", "#90caf9", "#bdbdbd"]}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", "0"]],
                    }}
                    legends={[
                      {
                        // anchor: 'center',
                        anchor: "center",
                        direction: "column",
                        // direction: 'column',
                        justify: false,
                        // translateX: 180,
                        translateX: 185,
                        translateY: 0,
                        itemsSpacing: 10,
                        itemWidth: 100,
                        // itemWidth: 100,
                        itemHeight: 18,
                        itemTextColor: "#535353",
                        itemDirection: "left-to-right",
                        itemOpacity: 1,
                        symbolSize: 18,
                        symbolShape: "circle",
                        effects: [
                          {
                            on: "hover",
                            style: {
                              itemTextColor: "#000",
                            },
                          },
                        ],
                      },
                    ]}
                    tooltip={(val) => {
                      return (
                        <div
                          className="row"
                          style={{
                            border: "1px #0060a8 solid",
                            backgroundColor: "#fff",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div className="col-12 col-md-12 col-lg-12">
                            <h5>
                              {" "}
                              {val.datum.id} : $
                              {Number(val.datum.value).toLocaleString("En-us")}{" "}
                            </h5>
                          </div>
                        </div>
                      );
                    }}
                    slicesLabelsSkipAngle={20}
                    arcLabelsTextColor="#000"
                    arcLabelsSkipAngle={20}
                    enableArcLinkLabels={false}
                    arcLabel={function (e) {
                      return "$" + Number(e.value).toLocaleString("En-us");
                    }}
                  />
                )}
                {/* <ChartComponent
                  type="PieChart"
                  data={
                    graphics.transport_mode.data
                      ? graphics.transport_mode.data
                      : []
                  }
                  width="100%"
                  height="300px"
                  options={{
                    colors: ["#2e86c1", "#4db6ac", "#90caf9", "#bdbdbd"],
                    // legend:"none",
                    pieHole: 0.4,
                    is3D: false,
                    chartArea: {
                      height: "93%",
                      width: "100%",
                    },
                    legend: {
                      alignment: "center",
                      // position:"none"
                    },
                    pieSliceText: "percentage",
                  }}
                /> */}
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 col-lg-6 mr-auto ml-auto ">
            <div className="card myCard equalsWidth">
              <div className="card-header">
                <div className="card-title" style={{ fontWeight: "bold" }}>
                  <div style={{ display: "flex" }} className="row">
                    <div className="col-md-8 col-lg-8 col-sm-8 col-8">
                      {params.t("Graphic4")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body" id="hAxisGraph">
                {!loader ? (
                  <FullLoader />
                ) : (
                  <ResponsiveBar
                    data={graphics.concept.data ? graphics.concept.data : []}
                    keys={["invoicing"]}
                    indexBy={(item) => {
                      return item.label.length > 21
                        ? `${item.label.substring(0, 17) + "..."}`
                        : item.label;
                    }}
                    tooltip={(item) => {
                      return (
                        <BasicTooltip
                          id={item.data.id}
                          value={currencyFormatter({
                            currency: "USD",
                            value: Number(item.data.invoicing),
                          })}
                          color={"#0060a8"}
                          enableChip
                        />
                      );
                    }}
                    margin={{ top: 0, right: 40, bottom: 50, left: 130 }}
                    padding={0.15}
                    layout="horizontal"
                    valueScale={{ type: "linear" }}
                    indexScale={{ type: "band", round: true }}
                    colors={"#0060a8"}
                    borderColor={{
                      from: "color",
                      modifiers: [["darker", 1.6]],
                    }}
                    theme={{
                      axis: {
                        fontSize: "14px",
                        tickColor: "#eee",
                        ticks: {
                          line: {
                            stroke: "#555555",
                          },
                          text: {
                            fill: "#535353",
                            // fontSize:'12px'
                          },
                        },
                        legend: {
                          text: {
                            fill: "#aaaaaa",
                          },
                        },
                      },
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 25,
                      // legend: 'country',
                      legendPosition: "middle",
                      legendOffset: 32,
                      format: function numberWithCommas(x) {
                        return (
                          "$" +
                          x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",")
                        );
                      },
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      // legend: 'food',
                      legendPosition: "middle",
                      legendOffset: -40,
                    }}
                    labelSkipWidth={12}
                    labelSkipHeight={12}
                    labelTextColor={{
                      from: "color",
                      modifiers: [["darker", 1.6]],
                    }}
                    enableLabel={false}
                  />
                  // <ChartComponent
                  //   type="BarChart"
                  //   data={graphics.concept.data ? graphics.concept.data : []}
                  //   width="100%"
                  //   height="300px"
                  //   options={{
                  //     chartArea: {
                  //       height: "85%",
                  //       width: "50%",
                  //       right: "2%",
                  //     },
                  //     legend: "none",
                  //     // hAxis: {
                  //     //   gridlines: {
                  //     //     count: 0,
                  //     //   },
                  //     //   textPosition: "none",
                  //     // },
                  //     vAxis: {
                  //       // baselineColor: "transparent",
                  //       // gridlines: {
                  //       //   count: 0,
                  //       // },
                  //       // textPosition: "none",
                  //     },
                  //   }}
                  // />
                )}
              </div>
            </div>
          </div>
          <div className="col-12">
            <span className="legend-graphic">
              <b>{params.t("legend_graphcis")}</b>
            </span>
          </div>
        </div>
        <div className="row pt-5">
          <div className="col-lg-12 col-sm-12 col-md-12 col-12">
            <Card className="myCard" style={{ padding: "15px" }}>
              <DataTable
                labelSelected={""}
                data={dataInvoice}
                columnsTable={columns}
                pages={totalPages}
                panel={true}
                filtrosPanel={filtros}
                subTable={subTable}
                handleSearch={setInvoiceSearch}
                OnPageChange={changePage}
                activePage={activeInvoicePage}
                downloadExcel={generateInvoiceExcel}
                excelLoading={excelInvoiceLoading}
                sumaryInfo={sumaryInfo}
                searchOnEnter={true}
                search={searchInvoice}
              />
            </Card>
          </div>
        </div>
      </ContentWrapper>
    </>
  );
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
});
export default withNamespaces()(connect(mapStateToProps)(withRouter(Finance)));
